import * as React from 'react'
import get from 'lodash-es/get'

import { IItemCard } from '../interface'
import AudioPlayerContainer from '../../audioPlayer/audioPlayerContainer'

import ItemCardSmallPreview from '../itemCardSmallPreview'

import * as styles from './lockupAudioPreview.module.css'

const LockupAudioPreview = (props: IItemCard) => {
  const { item } = props
  const src = get(item, 'previews.icon_with_audio_preview.mp3_url')
  const length = get(item, 'previews.icon_with_audio_preview.length')
  return (
    <div className={styles.root}>
      <span className={styles.icon}>
        <ItemCardSmallPreview {...props} />
      </span>
      <AudioPlayerContainer
        id={item.id}
        src={src}
        length={length}
        viewType={props.viewType}
      />
    </div>
  )
}

export default LockupAudioPreview
